import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Card,
  CardContent,
  Typography,
} from "@mui/material";
import { usePermissions } from "../../hooks/usePermissions";
import { IMPORT_ENTITY_PERMISSION, canUseImportExportPermission } from "../../utils/importExportPermissions";

const IMPORT_TYPES = [
  { key: "institutes", label: "Institutes", description: "Create institutes (new records)", template: "/csvDocuments/institutes_template.csv" },
  { key: "departments", label: "Departments", description: "Create departments (new records)", template: "/csvDocuments/departments_template.csv" },
  { key: "courses", label: "Courses", description: "Create courses (new records)", template: "/csvDocuments/courses_template.csv" },
  { key: "classes", label: "Classes", description: "Create classes (new records)", template: "/csvDocuments/classes_template.csv" },
  { key: "teachers", label: "Teachers", description: "Create teachers (new records)", template: "/csvDocuments/teachers_template.csv" },
  { key: "subjects", label: "Subjects", description: "Create subjects (new records)", template: "/csvDocuments/subjects_template.csv" },
  { key: "students", label: "Students", description: "Create students (new records)", template: "/csvDocuments/students_template.csv" },
  { key: "users", label: "Users", description: "Create users (new records)", template: "/csvDocuments/users_template.csv" },
];

const ImportTypeSelector = ({ open, onClose, onSelect, forUserSubtypes = false }) => {
  const { hasVisiblePermission, permissions, enabledModules } = usePermissions();
  const canImport = (slug) =>
    hasVisiblePermission(slug) || canUseImportExportPermission(enabledModules, permissions, slug);
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const isSuperAdmin =
    user?.role === "superadmin" || user?.isSuperAdmin ||
    (Array.isArray(user?.roles) && user.roles.includes("superadmin"));

  const USER_SUBTYPES = [
    { key: "teachers", label: "Teacher", description: "Teacher users" },
    { key: "hod", label: "HOD", description: "Head of Department users" },
    { key: "admin", label: "Admin", description: "Institute admin users" },
    { key: "students", label: "Student", description: "Student users" },
    { key: "superadmins", label: "Super Admin", description: "Global super admins" },
  ];

  const visibleTypes = (forUserSubtypes ? USER_SUBTYPES : IMPORT_TYPES).filter((t) => {
    if (t.key === "institutes" && !isSuperAdmin) return false;
    if (forUserSubtypes && t.key === "superadmins" && !isSuperAdmin) return false;
    const perm = IMPORT_ENTITY_PERMISSION[t.key];
    if (perm && !canImport(perm)) return false;
    return true;
  });

  return (
    <Dialog
      open={open}
      onClose={(e, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
        onClose?.();
      }}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle>Select Import Type</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {visibleTypes.map((t) => (
            <Grid item xs={12} sm={6} md={4} key={t.key}>
              <Card sx={{ cursor: "pointer" }} onClick={() => onSelect(t)}>
                <CardContent>
                  <Typography variant="h6">{t.label}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    {t.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportTypeSelector;
